import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonTabBar, IonTabButton, IonTabs, IonLabel, IonIcon, IonPage, IonRouterOutlet , IonHeader, IonTitle , IonBadge, IonToolbar, IonButton } from '@ionic/vue';
import { computed , onMounted } from 'vue';
import { document, cart, person, logoWhatsapp } from 'ionicons/icons';
import { useStore } from 'vuex';
import { key } from '../store/index';
import { useRouter } from 'vue-router';
import { Browser } from '@capacitor/browser';

// const cartitemnum: number = ref(0);

export default /*#__PURE__*/_defineComponent({
  __name: 'TabsPage',
  setup(__props) {

const store = useStore(key);

const router = useRouter();

onMounted(() =>{
  store.dispatch('getTokenData');
})


const cartitemnum: number = computed(()=>{
  return store.state.cart.length
})

const openHelp = async() => {
  await Browser.open({ url: 'https://wa.me/' + process.env?.VUE_APP_WHATSAPP_LOJA });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), { color: "danger" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTitle), { slot: "start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Menu Uniboi")
                ]),
                _: 1
              }),
              _createVNode(_unref(IonButton), {
                size: "small",
                fill: "outline",
                color: "dark",
                slot: "end",
                class: "btn-whatssapp",
                onClick: openHelp
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Ajuda "),
                  _createVNode(_unref(IonIcon), {
                    slot: "start",
                    icon: _unref(logoWhatsapp)
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonIcon), {
                collapse: false,
                slot: "end",
                icon: _unref(cart),
                onClick: _cache[0] || (_cache[0] = () => _unref(router).push('/tabs/carrinho'))
              }, null, 8, ["icon"]),
              _createVNode(_unref(IonBadge), {
                color: "dark",
                slot: "end"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(cartitemnum)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonTabs), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRouterOutlet)),
          _createVNode(_unref(IonTabBar), {
            slot: "bottom",
            color: "danger"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTabButton), {
                tab: "tab1",
                href: "/tabs/menu"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { icon: _unref(document) }, null, 8, ["icon"]),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode("Menu")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTabButton), {
                tab: "tab2",
                href: "/tabs/carrinho"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { icon: _unref(cart) }, null, 8, ["icon"]),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode("Carrinho")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTabButton), {
                tab: "tab3",
                href: "/tabs/conta"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { icon: _unref(person) }, null, 8, ["icon"]),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode("Conta")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})